import { AxiosResponse } from "axios";
import { call, delay, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failurePolicyMasterRead,
  successPolicyMasterRead,
} from "./PolicyMasterRead";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failurePolicyCreate_Update,
  successPolicyCreate_Update,
} from "./policyMasterCreate_Update";
import {
  failurePrivacy_PolicyRead,
  successPrivacy_PolicyRead,
} from "./PrivacyPolicyRead";
import {
  failureTerms_and_ConditionRead,
  successTerms_and_ConditionRead,
} from "./TeramsandConditionRead";

// list
const ListPolicyApi = () => {
  return api.get("/api/template/get-templates");
};

export function* ListPoicyCall() {
  try {
    const response: AxiosResponse = yield call(ListPolicyApi);
    yield put(successPolicyMasterRead(response.data));
  } catch (error) {
    yield put(failurePolicyMasterRead(error));
  }
}

const Policy_Create_UpdateApi = (action: PayloadAction<any>) => {
  return api.post("/api/template/create-edit-template", action.payload);
};

export function* Policy_Create_UpdateCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(Policy_Create_UpdateApi, action);
    yield put(successPolicyCreate_Update(response.data));
  } catch (error) {
    yield put(failurePolicyCreate_Update(error));
  }
}

const ListPrivacyPolicyApi = () => {
  return api.get("/api/template/privacy-policy");
};

export function* ListPrivacyPoicyCall() {
  try {
    const response: AxiosResponse = yield call(ListPrivacyPolicyApi);
    yield put(successPrivacy_PolicyRead(response.data));
  } catch (error) {
    yield put(failurePrivacy_PolicyRead(error));
  }
}

const ListTerms_and_Condition_Api = () => {
  return api.get("api/template/terms-conditions");
};

export function* ListTerms_and_Conditon_Call() {
  try {
    const response: AxiosResponse = yield call(ListTerms_and_Condition_Api);
    yield put(successTerms_and_ConditionRead(response.data));
  } catch (error) {
    yield put(failureTerms_and_ConditionRead(error));
  }
}
